import { useReducer } from "react";
export const useForceUpdate = () => {
    const [, forceUpdate] = useReducer((value) => value + 1, 0);
    return forceUpdate;
};
